

const SERVICES = {
  dashboard: {
    title: 'navbar.Tree.Dashboard.Title',
    link: '/',
    options: {
      YourDashboard: {
        title: 'navbar.Tree.Dashboard.Options.YourDashboard',
        link: '/',
      },
    },
    isActive: (currentPath) => {
      return currentPath === '/' || currentPath.startsWith('/dashboard');
    },
  },
  profile: {
    title: 'navbar.Tree.Profile.Title',
    link: '/profile/client_profile',
    options: {
      YourDashboard: {
        title: 'navbar.Tree.Profile.Options.Profile',
        link: '/profile/client_profile',
      },
    },
    isActive: (currentPath) => {
      return currentPath.startsWith('/profile');
    },
  },
};

export default SERVICES;
